<template>
    <div class="shared-assignments-databank">
        <div
            class="shared-assignments"
            v-if="!preview">
            <div class="row">
                <div class="col-12 col-md-4 col-lg-3 shared-assignments-filters">
                    <design-2021-portfolio-edit-shared-assignments-filters-component
                        v-model="filters"
                        :education-levels="educationLevels"
                        :assignments-in="assignments">
                    </design-2021-portfolio-edit-shared-assignments-filters-component>
                </div>

                <div class="col-12 offset-md-2 col-md-6 offset-lg-0 col-lg-9">
                    <design-2021-portfolio-edit-shared-assignment-card-component
                        :assignments-in="assignments"
                        :is-loading="isLoading"
                        :filters="filters"
                        :group-id="groupId"
                        :portfolio-category-id="portfolioCategoryId"
                        :preview-mode-only="previewModeOnly"
                        @add-assignment-to-assignments="addAssignment"
                        @preview-assignment="previewSelectedAssignment">
                    </design-2021-portfolio-edit-shared-assignment-card-component>
                </div>
            </div>
        </div>
        <div
            class="preview"
            v-else>
            <design-2021-assignment-show-component :assignment-in="assignment"> </design-2021-assignment-show-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignments-databank-component',
    props: {
        courseId: {
            type: Number,
            default() {
                return 0;
            },
        },
        educationLevelsIn: {
            type: Array,
            default() {
                return [];
            },
        },
        groupId: {
            type: Number,
            default() {
                return 0;
            },
        },
        portfolioCategoryId: {
            type: Number,
            default() {
                return 0;
            },
        },

        previewIn: {
            type: Boolean,
            default() {
                return false;
            },
        },

        previewModeOnly: Boolean,
    },
    data() {
        return {
            assignments: [],
            assignment: {},
            sharedFilterAssignments: [],
            isLoading: false,
            filters: {},
            preview: false,
            educationLevels: this.educationLevelsIn,
        };
    },

    created() {
        this.getAssignments();
    },

    methods: {
        getFilters(filters) {
            this.filters = { ...filters };
        },

        getAssignments() {
            this.isLoading = true;
            // todo atm we are loading everything, should be changed in the future
            axios.get(this.routes.getabAssignmentsByCourse()).then(
                (response) => {
                    if (response.data.length) {
                        this.assignments = response.data;
                        this.sharedFilterAssignments = this.assignments;
                    }

                    this.isLoading = false;
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('assignment.error_retrieving_shared_commands'));
                },
            );
        },

        addAssignment(assignment) {
            this.$emit('add-assignment-to-list', assignment);
        },

        previewSelectedAssignment(abAssignmentId) {
            this.axios.get(`ab/assignment/${abAssignmentId}`).then(
                (response) => {
                    this.assignment = response.data;
                    this.preview = true;
                    this.$emit('update-preview-status', this.preview);
                },

                (error) => {
                    this.preview = false;
                    this.$emit('update-preview-status', this.preview);
                    this.alert.ajaxError(error);
                },
            );
        },

        closePreviewedAssignment() {
            this.assignment = {};
            this.preview = !this.preview;
            this.$emit('update-preview-status', this.preview);
        },

        oncancel(bvModalEvt) {
            this.preview = !this.preview;
            this.$emit('update-preview-status', this.preview);
            bvModalEvt.preventDefault();
        },
    },

    watch: {
        isLoading: function (value) {
            this.isLoading = value;
        },

        previewIn: function (status) {
            this.preview = status;
        },
    },
};
</script>

<style scoped>
.shared-assignments-databank:nth-child(2) {
    margin-bottom: 48px;
    margin-top: 48px;
}

. shared-assignment-modal >>> .modal-header {
    justify-content: space-between;
    align-items: center;
}

.btn-shared-assignment-back {
    margin-left: auto;
    margin-right: 15px;
}

.btn-shared-assignment-close {
    padding: 5px 0 5px 5px;
    opacity: 0.5;
}

.btn-shared-assignment-close,
.btn-shared-assignment-close:hover {
    color: #000;
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
}

.btn-shared-assignment-close:hover {
    opacity: 0.75;
}

.shared-assignments-filters {
    margin-bottom: 30px;
}

.preview >>> .container-with-shadow {
    box-shadow: none;
}

@media (min-width: 992px) {
    .shared-assignments-filters {
        margin-bottom: 0;
    }
}
</style>
